export default __webpack_public_path__ + "static/paul-head-shot-7a52eb76bd9667f4c7dfe9cefccaf65c.jpeg";